import React from "react";
import AutorenewIcon from "@material-ui/icons/Autorenew";

const OrcamentoTopo = (props) => {
	return (
		<div className="mb-1">
			{props.infoUsers && props.infoUsers.negocio && (
				<div className="quoteInfoUsers">
					<div className="p-1 ">
						<b>Consultor: </b>
						{props.infoUsers.negocio.consultor.nome} - <b>Cliente: </b>
						{props.infoUsers.negocio.pessoa.nome}
					</div>
					<div className="mr-1">{props.children}</div>
				</div>
			)}
			{!props.infoUsers && (
				<div className="text-center">
					<AutorenewIcon className="spin" />
				</div>
			)}
		</div>
	);
};

export default OrcamentoTopo;
